import React from 'react';
import PropTypes from 'prop-types';
import './standardArticleCustom.css';
import { StandardArticle } from '../../../ui/src/component/article';
import { CsmSectionLink } from '../../../ui/src/component/csmSectionLink';
import moment from 'moment';
import { calendarTime, getProp } from '../../../ui/src/utilities.js';

const StandardArticleCustom = props => {
  const creationDate = calendarTime(moment(props.article.date));

  let location = getProp(props.article, 'location', []);

  let subtitle = '';
  if (props.author !== null) {
    subtitle = `${props.author.toLocaleUpperCase()}, ${creationDate}`;
  } else if (location.length > 0) {
    subtitle = `${location[0].title.toLocaleUpperCase()}, ${creationDate}`;
  } else {
    subtitle = creationDate;
  }

  let sectionName = getProp(props.article, 'section.name', undefined);
  let section = getProp(props.article, 'section', null);

  return (
    <StandardArticle
      article={props.article}
      articleTitleSubtitle={props.articleTitleSubtitleShow ? subtitle : null}
      articleTitleExtra={props.articleTitleExtraShow ? sectionName : null}
      viewCountShow={props.viewCountShow}
      pictureSize={props.pictureSize}
      baseUrl={props.baseUrl}
      imgOverride={props.imgOverride}
      extended={props.extended}
      allowShare={props.allowShare}
      articleAuthorSubtitle={
        section && props.extended ? <CsmSectionLink section={section} /> : null
      }
      size={props.size}
      articleHeadContent={props.articleHeadContent}
    />
  );
};

StandardArticleCustom.defaultProps = {
  viewCountShow: false,
  author: null,
  baseUrl: '',
  extended: false,
  allowShare: true,
  articleTitleSubtitleShow: true,
  articleTitleExtraShow: true,
};

StandardArticleCustom.propTypes = {
  article: PropTypes.object.isRequired,
  viewCountShow: PropTypes.bool,
  pictureSize: PropTypes.number,
  author: PropTypes.string,
  baseUrl: PropTypes.string,
  imgOverride: PropTypes.string,
  extended: PropTypes.bool,
  allowShare: PropTypes.bool,
  size: PropTypes.string,
  articleTitleSubtitleShow: PropTypes.bool,
  articleTitleExtraShow: PropTypes.bool,
  articleHeadContent: PropTypes.node,
};

export default StandardArticleCustom;



// WEBPACK FOOTER //
// ./src/app/component/standardArticleCustom/standardArticleCustom.js